import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginWithOtp from "./LoginWithOtp";
import LoginWithPassword from "./LoginWithPassword";
import LoginWithUserNameOrPassword from "./Login";

const Welcome = () => {
    const navigate = useNavigate();
    const [currentState, setCurrentState] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [email, setEmail] = useState("");

    const onNextClick = (nextState) => {
        setCurrentState(nextState);
    };

    const currentComponent = () => {
        switch (currentState) {
            case "loginWithOtp":
                return (
                    <LoginWithOtp
                        mobileNo={mobileNo}
                        onCancelClick={() => onNextClick("")}
                    />
                );
            case "loginWithPassword":
                return (
                    <LoginWithPassword
                        email={email}
                        onCancelClick={() => onNextClick("")}
                    />
                );

            default:
                return (
                    <LoginWithUserNameOrPassword
                        setEmail={setEmail} // Corrected prop name
                        setMobileNo={setMobileNo}
                        onNextClick={(msg) => onNextClick(msg)}
                    />
                );
        }
    };

    return <>{currentComponent()}</>;
};

export default Welcome;
